import { useSession } from '@/features/auth/mutations'

/**
 * Whether this person may use the copilot at all.
 *
 * Anyone signed in. The backend dropped the `copilot.use` permission and its module
 * on 2026-10-05 (`8036308`): every copilot route now depends on `get_current_user`
 * alone, and a session and its turns are private to the person who created them.
 *
 * This hook used to test `usePermission('copilot.use')`. Once the permission stopped
 * existing nobody could hold it, so the dock was offered to root users only — and to
 * nobody else, with no error anywhere. It is kept as a hook rather than inlined so
 * that a permission coming back is one edit here.
 *
 * `isPending` is distinct from "refused" on purpose. Treating a session that has not
 * loaded as absent flashes a refusal at every reader on every cold start.
 */
export function useCopilotAccess() {
  const session = useSession()
  return {
    isPending: session.isPending && !session.data,
    granted: Boolean(session.data?.user),
  }
}
